/**
 * This is a manual helper typing for the LeaseChange.category (string) type
 */
export enum LeaseChangeCategory {
  EoC = 'EoC',
  MLC = 'MLC',
  ERR = 'ERR',
}
